{
  "lang": "nl",
  "alias": "rvr-wsnp",
  "theme": "bare",
  "master": "masters/bare/rvr-wsnp",
  "plugins": [
    "a11y-describedby",
    "a11y-user-detect",
    "all-or-nothing",
    "asterisk",
    "auto-next-when-only-radio",
    "bb-input-wrap-and-unit",
    "busy",
    "chapters",
    "convert-metadata",
    "edit-earlier-direct",
    "grid-tabs",
    "has-required",
    "headings",
    "history",
    "jumplist-prefill",
    "markdown-it",
    "markdown-it-converter",
    "md-labels",
    "metadata-change-navtext",
    "no-menu",
    "nonce-metatag",
    "nta:proxymap",
    "piwik-pro-nonce",
    "postcode-soap-meta",
    "previews",
    "shout-out-resize",
    "show-server-side-validation",
    "skip",
    "uploads",
    "user-error-focus-first",
    "wbtv:translations",
    "wrap-table"
  ],
  "overrideinloghtml": "wsnp.html",
  "arbitrary": {
    "headings": {
      "baseLevel": "2"
    },
    "core": {
      "skipNumButtons": true,
      "wrapAllSingleLiners": true,
      "putAddRowButtonBelowGrid": true,
      "form-group": {
        "on": true,
        "names": {
          "grouping-class": "form-group",
          "grouping-prefix-type-": "form-group-",
          "question-class": "form-group__question bb-questionlabelgroup",
          "question-prefix-type": "form-group__question-",
          "question-data-layout": "data-form-group-layout",
          "question-prefix-authorstyle": "form-group__question--author-style-"
        },
        "toplevel": true
      },
      "editPolicy": "return"
    },
    "info-inline": {
      "buttonplacement": "beforeend"
    },
    "previews": {
      "showChanges": true
    },
    "postcode-soap-meta": {
      "huisnummer-required": true
    },
    "busy": {
      "on": "bb:prePost",
      "off": "bb:postHandleData bb:jsonError bb:hasUpdated"
    },
    "form-group": {
      "edit": "below",
      "numedit": "below",
      "checkbox": "inline",
      "datetimepicker": "below",
      "combobox": "below",
      "freebox": "below",
      "linklabel": "below",
      "listlabel": "below",
      "memo": "below",
      "checkmultilist": "below",
      "multilist": "below",
      "grid": "below",
      "listbox": "below",
      "radio": "below"
    },
    "parentDomain": [
      "https://rvr.org",
      "https://www.rvr.org",
      "https://bureauwbtv.nl/",
      "https://www.bureauwbtv.nl/",
      "https://bureauwsnp.nl/",
      "https://www.bureauwsnp.nl/",
      "https://rechtsbijstand.nl/",
      "https://www.rechtsbijstand.nl/",
      "https://rechtwijzer.nl/",
      "https://www.rechtwijzer.nl/",
      "https://raadvoorrechtsbijstand.org/",
      "https://www.raadvoorrechtsbijstand.org/",
      "https://redactie.rvr.org/"
    ],
    "shout-out-resize": {
      "leeway": 84
    },
    "title": "Wet Schuldsanering Natuurlijke Personen",
    "piwik": {
      "fallback": {
        "code": "1cb006c7-51c6-4a48-a7bf-ebd3e28b0fd1",
        "endpoint": "https://rvr.containers.piwik.pro/"
      }
    }
  },
  "template": {
    "less": {
      "post": [
        "custom.less"
      ]
    },
    "themeColor": "rgb(188, 79, 36)",
    "readonly-prop": "disabled"
  },
  "legacy": false,
  "fonts": [
    "source-serif-pro-v11",
    "nunito-sans-v6"
  ]
}
